import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class CardLabel extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    labelCode: PropTypes.string,
  }

  static defaultProps = {
    labelCode: null,
  }

  render() {
    let labelCode = this.props.labelCode || this.props.label;
    labelCode = labelCode.replace(/\s+/g, '-').toLowerCase();
    return (
      <div className={`Card-label u-font-bold u-py-2 u-px-4 u-bt-color-${labelCode} u-text-color-${labelCode}`}>
        { this.props.label }
      </div>
    );
  }
}
